import { configureStore } from "@reduxjs/toolkit";
import { api } from "../features/api/api";
import sidebarReducer from "../features/Toggle/sidebarSlice";
// import sidebarReducer from "../features/Toggle/sidebarSlice";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    sidebar: sidebarReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});
